module.exports = __webpack_public_path__ + "media/images/wallet-icon-31f8aecf2b72331130e68a2ca8bff30a.png";